import React from 'react'

export const Navbar = () => {
  return (
    <>
    <nav class="navbar navbar-expand-lg sticky-top" style={{backgroundColor: "#e3f2fd"}}>
  <div className="container-fluid">
    <a className="navbar-brand" href="/">SuperSystems </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="/">Inicio</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#mision">Mision</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#vision">Vision</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
    </>
  )
}
